import React from 'react';
import './styles.css';

const GlassCard = ({ children, className = '', borderRadius = '15px', hoverEffect = true, ...rest }) => {
  const cardClasses = `glass-card ${hoverEffect ? 'hover-effect' : ''} ${className}`;

  return (
    <div className={cardClasses} style={{ borderRadius: borderRadius }} {...rest}>
      {children}
    </div>
  );
};

export default GlassCard;
